// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: when something in an agent thread happened (2026-10-11): a quiet clock time on prompts,
// replies, steps, approvals, questions and pull requests, with the full moment on hover.

import {fullTime, itemTime} from '@app/features/konvo_agents/components/AgentsCopy';
import styles from '@app/features/konvo_agents/components/AgentTime.module.css';
import Agents from '@app/features/konvo_agents/state/Agents';
import {shouldUse12HourFormat} from '@app/features/user/utils/DateFormatting';
import {useLingui} from '@lingui/react/macro';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';

export const AgentTime = observer(
	({at, className, flx}: {at: string | number | null | undefined; className?: string; flx?: string}) => {
		const {i18n} = useLingui();
		const time = typeof at === 'number' ? at : at ? Date.parse(at) : Number.NaN;
		if (!Number.isFinite(time)) return null;
		const hour12 = shouldUse12HourFormat(i18n.locale);
		return (
			<time
				className={clsx(styles.time, className)}
				dateTime={new Date(time).toISOString()}
				title={fullTime(i18n, time, hour12)}
				data-flx={flx ?? 'konvo-agents.time'}
			>
				{itemTime(i18n, time, Agents.minute, hour12)}
			</time>
		);
	},
);
